import { ref, watch } from 'vue'

export const showDeactivatedUsers = ref(
  window.localStorage.getItem('showDeactivatedUsers') === 'true'
)

watch(showDeactivatedUsers, () => {
  window.localStorage.setItem(
    'showDeactivatedUsers',
    `${showDeactivatedUsers.value}`
  )
})
